const orderStatusesAutoChange = {
  Authorized: {
    autoChangeStatus: 'To Be Delivered',
    autoChangeState: 'delivery',
  },
  Delivered: {
    autoChangeStatus: 'To Be Billed',
    autoChangeState: 'billing',
  },
  Repaired: {
    autoChangeStatus: 'To Be Billed',
    autoChangeState: 'billing',
  },
  'Discontinue Service': {
    autoChangeStatus: 'To Be Billed',
    autoChangeState: 'billing',
  },
  Billed: {
    autoChangeStatus: 'To Be Collected',
    autoChangeState: 'collection',
  },
  'Claim Mailed': {
    autoChangeStatus: 'Claim in Process',
    autoChangeState: 'collection',
  },
};

export default orderStatusesAutoChange;



// WEBPACK FOOTER //
// ./src/config/orderStatusesAutoChange.js